import React, { useState, useEffect } from 'react';
import {
    StyleSheet,
    Image,
    FlatList,
    View,
    TouchableOpacity,
    ScrollView,
    ImageBackground,
    Platform,
} from 'react-native';
import { useSelector } from 'react-redux';
import Screen from './../components/shared/Screen';
import TblShow from './../components/shared/TblShow';
import ToplearnText from './../components/shared/ToplearnText';
import CustomButton from './../components/shared/CustomButton';
import { getKholasehVaziat, getVarizha } from './../actions/index';
import { loadingToast } from '../utils/toasts';
import Toast from 'react-native-tiny-toast';
import { useDispatch } from 'react-redux';

const NewCoursesScreen = () => {
    const dispatch = useDispatch();
    const kholasehVaziat = useSelector((state) => state.kholasehVaziats);
    const defaultColor = 'gray';
    const selectColor = 'tomato';
    const [selectItem, setSelectItem] = useState(1);
    const scrollRef = React.useRef(null);

    useEffect(() => {
        try {
            const fetchData = async () => {
                loadingToast('در حال بارگذاری...');
                dispatch(
                    getVarizha({
                        hesab:
                            kholasehVaziat.length !== 0
                                ? kholasehVaziat[0].hesab
                                : 0,
                    })
                );
                Toast.hide();
            };
            fetchData();
        } catch (err) {
            console.log(err);
            Toast.hide();
        }
    }, [kholasehVaziat]);

    const vrzsha = useSelector((state) => state.varizhas);
    let vrzs = vrzsha;
    switch (selectItem) {
        case 2:
            vrzs = vrzsha.filter((x) => x.bpdSepordeh > 0);
            break;
        case 3:
            vrzs = vrzsha.filter((x) => x.bpdZarori > 0);
            break;
        case 4:
            vrzs = vrzsha.filter((x) => x.bpdKargoshaie > 0);
            break;
        case 5:
            vrzs = vrzsha.filter((x) => x.bpdKarmozdVam > 0);
            break;
        case 6:
            vrzs = vrzsha.filter((x) => x.bpdJrmDirkard > 0);
            break;
        default:
            break;
    }
    console.log('vrzs:',vrzs)
    return (
        <Screen style={styles.container}>
            <Image
                blurRadius={2}
                style={styles.headerImage}
                source={require('../assets/pardakht.jpg')}
            />
            <View style={styles.header}>
                <ToplearnText
                    fontFamily="yekan"
                    size="2"
                    // color="#fff"
                >
                    پرداختی ها
                </ToplearnText>
                <ToplearnText
                    fontFamily="yekan"
                    size="1.5"
                    // color="#fff"
                >
                    {kholasehVaziat.length !== 0
                        ? kholasehVaziat[0].firstName
                        : '-'}{' '}
                    {kholasehVaziat.length !== 0
                        ? kholasehVaziat[0].lastName
                        : '-'}
                </ToplearnText>
                <View style={styles.imgHeaderTXTfilter}>
                    <TouchableOpacity
                        style={[
                            styles.button,
                            {
                                backgroundColor:
                                    selectItem === 1
                                        ? selectColor
                                        : defaultColor,
                            },
                        ]}
                        onPress={() => {
                            setSelectItem(1);
                        }}
                    >
                        <ToplearnText
                            fontFamily="yekan"
                            size="1.5"
                            styles={styles.text}
                        >
                            همه
                        </ToplearnText>
                    </TouchableOpacity>
                    <TouchableOpacity
                        style={[
                            styles.button,
                            {
                                backgroundColor:
                                    selectItem === 2
                                        ? selectColor
                                        : defaultColor,
                            },
                        ]}
                        onPress={() => {
                            setSelectItem(2);
                        }}
                    >
                        <ToplearnText
                            fontFamily="yekan"
                            size="1.5"
                            styles={styles.text}
                        >
                            عادی/سپرده
                        </ToplearnText>
                    </TouchableOpacity>
                    <TouchableOpacity
                        style={[
                            styles.button,
                            {
                                backgroundColor:
                                    selectItem === 3
                                        ? selectColor
                                        : defaultColor,
                            },
                        ]}
                        onPress={() => {
                            setSelectItem(3);
                        }}
                    >
                        <ToplearnText
                            fontFamily="yekan"
                            size="1.5"
                            styles={styles.text}
                        >
                            ضروری
                        </ToplearnText>
                    </TouchableOpacity>
                    <TouchableOpacity
                        style={[
                            styles.button,
                            {
                                backgroundColor:
                                    selectItem === 4
                                        ? selectColor
                                        : defaultColor,
                            },
                        ]}
                        onPress={() => {
                            setSelectItem(4);
                        }}
                    >
                        <ToplearnText
                            fontFamily="yekan"
                            size="1.5"
                            styles={styles.text}
                        >
                            کارگشایی
                        </ToplearnText>
                    </TouchableOpacity>
                    <TouchableOpacity
                        style={[
                            styles.button,
                            {
                                backgroundColor:
                                    selectItem === 5
                                        ? selectColor
                                        : defaultColor,
                            },
                        ]}
                        onPress={() => {
                            setSelectItem(5);
                        }}
                    >
                        <ToplearnText
                            fontFamily="yekan"
                            size="1.5"
                            styles={styles.text}
                        >
                            کارمزد وام
                        </ToplearnText>
                    </TouchableOpacity>
                    <TouchableOpacity
                        style={[
                            styles.button,
                            {
                                backgroundColor:
                                    selectItem === 6
                                        ? selectColor
                                        : defaultColor,
                            },
                        ]}
                        onPress={() => {
                            setSelectItem(6);
                        }}
                    >
                        <ToplearnText
                            fontFamily="yekan"
                            size="1.5"
                            styles={styles.text}
                        >
                            جریمه
                        </ToplearnText>
                    </TouchableOpacity>
                </View>
            </View>
            {Platform.OS === 'web' ? (
                <ScrollView style={styles.fltlstStyle}>
                    <FlatList
                        data={vrzs}
                        keyExtractor={(vrz) => vrz._id.toString()}
                        renderItem={({ item }) => (
                            <TblShow
                                bpdSepordeh={
                                    item.bpdSepordeh ? item.bpdSepordeh : 0
                                }
                                bpdAdi={item.bpdAdi ? item.bpdAdi : 0}
                                bpdKargoshaie={
                                    item.bpdKargoshaie ? item.bpdKargoshaie : 0
                                }
                                bpdZarori={item.bpdZarori ? item.bpdZarori : 0}
                                tarikhPardakht={
                                    item.tarikhPardakht
                                        ? item.tarikhPardakht
                                        : 0
                                }
                                shomarehPeygiri={
                                    item.shomarehPeygiri
                                        ? item.shomarehPeygiri
                                        : 0
                                }
                                mablaghKol={
                                    item.mablaghKol ? item.mablaghKol : 0
                                }
                                bpdKarmozdVam={
                                    item.bpdKarmozdVam ? item.bpdKarmozdVam : 0
                                }
                                bpdSodBanki={
                                    item.bpdSodBanki ? item.bpdSodBanki : 0
                                }
                                bpdKomak={item.bpdKomak ? item.bpdKomak : 0}
                                bpdJrmDirkard={
                                    item.bpdJrmDirkard ? item.bpdJrmDirkard : 0
                                }
                                bpdTozihat={
                                    item.bpdTozihat ? item.bpdTozihat : 0
                                }
                                srdAdi={item.srdAdi ? item.srdAdi : 0}
                                srdKargoshaie={
                                    item.srdKargoshaie ? item.srdKargoshaie : 0
                                }
                                srdZarori={item.srdZarori ? item.srdZarori : 0}
                            />
                        )}
                    />
                </ScrollView>
            ) : (
                <View style={styles.fltlstStyle}>
                    <FlatList
                        data={vrzs}
                        keyExtractor={(vrz) => vrz._id.toString()}
                        renderItem={({ item }) => (
                            <TblShow
                                bpdSepordeh={
                                    item.bpdSepordeh ? item.bpdSepordeh : 0
                                }
                                bpdAdi={item.bpdAdi ? item.bpdAdi : 0}
                                bpdKargoshaie={
                                    item.bpdKargoshaie ? item.bpdKargoshaie : 0
                                }
                                bpdZarori={item.bpdZarori ? item.bpdZarori : 0}
                                tarikhPardakht={
                                    item.tarikhPardakht
                                        ? item.tarikhPardakht
                                        : 0
                                }
                                shomarehPeygiri={
                                    item.shomarehPeygiri
                                        ? item.shomarehPeygiri
                                        : 0
                                }
                                mablaghKol={
                                    item.mablaghKol ? item.mablaghKol : 0
                                }
                                bpdKarmozdVam={
                                    item.bpdKarmozdVam ? item.bpdKarmozdVam : 0
                                }
                                bpdSodBanki={
                                    item.bpdSodBanki ? item.bpdSodBanki : 0
                                }
                                bpdKomak={item.bpdKomak ? item.bpdKomak : 0}
                                bpdJrmDirkard={
                                    item.bpdJrmDirkard ? item.bpdJrmDirkard : 0
                                }
                                bpdTozihat={
                                    item.bpdTozihat ? item.bpdTozihat : 0
                                }
                                srdAdi={item.srdAdi ? item.srdAdi : 0}
                                srdKargoshaie={
                                    item.srdKargoshaie ? item.srdKargoshaie : 0
                                }
                                srdZarori={item.srdZarori ? item.srdZarori : 0}
                            />
                        )}
                    />
                </View>
            )}
        </Screen>
    );
};

export default NewCoursesScreen;

const styles = StyleSheet.create({
    container: {
        alignItems: 'center',
    },
    headerImage: {
        width: '98%',
        resizeMode: 'cover',
        borderRadius: 15,
        height: Platform.OS === 'web' ? 160 : 90,
        marginBottom: 20,
    },
    header: {
        position: 'absolute',
        width: '98%',
        padding: 5,
        alignItems: 'center',
    },
    fltlstStyle: {
        width: '95%',
    },
    button: {
        borderRadius: 13,
        justifyContent: 'center',
        alignItems: 'center',
        width: '15%',
        height: Platform.OS === 'web' ? '95%' : '55%',
        padding: 5,
        margin: 5,
    },
    imgHeaderTXTfilter: {
        flexDirection: 'row',
        width: '100%',
        justifyContent: 'space-evenly',
        alignItems: 'center',
        marginTop: 10,
    },
});
